import {Component, OnDestroy, OnInit} from '@angular/core';
import {interval, Observable, Subscription} from "rxjs";
import {cIO_MODBUS_ROOT, cIO_MODBUS_TREE} from "../modbusData";
import {ModbusDescriptionDataservice} from "../ModbusDescriptionDataservice";
import {MeasurementSlotDetailsComponent} from "../../measurementsslots/measurementslot-details/measurement-slot-details.component";
import {ModbusdetailsComponent} from "../modbusdetails/modbusdetails.component";
import {environment} from "../../../environments/environment";
import {dummy_modbusdata} from "../../dummydata/dummy_modbusdata";

@Component({
  selector: 'app-modbuslister',
  templateUrl: './modbuslist.component.html',
  styleUrls: ['./modbuslist.component.css']
})
export class ModbuslistComponent implements OnInit, OnDestroy {
  private updateSubscription: Subscription | undefined;
  modbusRoot: cIO_MODBUS_ROOT | undefined;
  modbusDetailList = Array<ModbusdetailsComponent>();
  public loaderStatus: number = 0;

  constructor(private modbusserDescriptionDataservice: ModbusDescriptionDataservice) {
  }

  ngOnInit(): void {
    console.log('MODBUS ONINIT');
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  ngOnDestroy(): void {
    console.log('MODBUS DESTROY');
    this.updateSubscription?.unsubscribe();
  }

  FindTree(refNumber: number): cIO_MODBUS_TREE {
    if (this.modbusRoot) {
      for (let world of this.modbusRoot.cIO_MODBUS_WORLD) {
        for (let node of world.cIO_MODBUS_TREE) {
          if (node.nodeid == refNumber)
            return node;
        }
      }
    }
    return new cIO_MODBUS_TREE();
  }

  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;

    if(environment.useDummyData) {
      this.loaderStatus = 1;
      // Copy the WHOLE list into this class
      this.modbusRoot = dummy_modbusdata;
      for (let detail of this.modbusDetailList) {
        detail.UpdateStatus(this.FindTree(detail.refNumber));
      }
    } else {
      this.modbusserDescriptionDataservice.GetData().subscribe({
        next: modbusRoot => {
          this.loaderStatus = 1;
          // Copy the WHOLE list into this class
          this.modbusRoot = modbusRoot;
          for (let detail of this.modbusDetailList) {
            detail.UpdateStatus(this.FindTree(detail.refNumber));
          }
          this.ReSubscribe();
        }
      });
    }
  }


  counter(i: number) {
    return new Array(i);
  }

  Add(modbusdetailsComponent: ModbusdetailsComponent): void {
    this.modbusDetailList.push(modbusdetailsComponent);
  }


}
